import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makesLoaded, makesResolved, setSelectedMakes } from '../features/make/makeSlice';

const FILTER_UPDATE_TOPIC = 'ws-locations-data/filtered-locations';

export const useMakeFacets = (isReady) => {
	const dispatch = useDispatch();
	const hasResolvedRef = useRef(false);
	const selectedMakes = useSelector((state) => state.make.selectedMakes);

	useEffect(() => {
		if (!isReady || !window.DDC?.LocationsData) {
			return () => {};
		}

		const locationsData = window.DDC.LocationsData;

		const handleLocationsUpdate = () => {
			const facets = locationsData.getMakeFacets() || [];
			dispatch(makesLoaded(facets));
			// Only mark as resolved on the first load — subsequent location
			// updates (postal code / radius changes) should not re-fire this.
			if (!hasResolvedRef.current) {
				dispatch(makesResolved());
				hasResolvedRef.current = true;
			}
		};

		// Derive facets from the current location set immediately
		handleLocationsUpdate();

		// Subscribe for future location updates (postal code / radius changes)
		const unsubscribe = locationsData.registerLocationsNotification(
			handleLocationsUpdate
		);

		return () => {
			if (unsubscribe) {
				unsubscribe();
			}
		};
	}, [isReady, dispatch]);

	useEffect(() => {
		// Subscribe to DDC pubsub topic for filter updates.
		const handleFilterChange = () => {
			const makes = window.DDC.LocationsData.getActiveMakes();
			if (selectedMakes.some((make) => !makes.includes(make))) {
				// If the current selectedMakes includes any makes that are no longer active,
				// we need to update the Redux state to reflect the change.
				dispatch(setSelectedMakes(makes));
			}
		};
		const pubsub = window.DDC?.pubsub;
		if (pubsub) {
			pubsub.subscribe(FILTER_UPDATE_TOPIC, handleFilterChange);
		}

		return () => {
			if (pubsub) {
				pubsub.unsubscribe(FILTER_UPDATE_TOPIC, handleFilterChange);
			}
		}
	}, [isReady, dispatch, selectedMakes]);
};
